import React, { useEffect, useState } from "react";
import { useEspelhoVendas } from "services/api/AppWeb_EspelhoVendas";
import * as Styles from "./styles";
import Header from "./Header";
import Footer from "./Footer";

interface Props {
  onClose: () => void;
  tableData: any;
  refetch: () => void;
  idLeadCorretor: string;
}

const AdicionarItemModal: React.FC<Props> = (props) => {
  return (
    <Styles.Container>
      <Header onClose={() => props?.onClose()} />
      <Footer
        onClose={() => props?.onClose()}
        tableData={props?.tableData}
        refetch={props?.refetch}
        idLeadCorretor={props?.idLeadCorretor}
      />
    </Styles.Container>
  );
};

export default AdicionarItemModal;
